// extracted by mini-css-extract-plugin
export var steps = "steps-module--steps--1eu3L";
export var steps__wrap = "steps-module--steps__wrap--210nQ";
export var steps__divider = "steps-module--steps__divider--GRB7H";
export var steps__step = "steps-module--steps__step--2UMjo";
export var steps__step__overlay = "steps-module--steps__step__overlay--1LbBM";
export var steps__step__text = "steps-module--steps__step__text--2C9hn";
export var steps__step__wrap = "steps-module--steps__step__wrap--2vLB7";
export var steps__step__arrow = "steps-module--steps__step__arrow--3_J57";